<mat-dialog-content>
  <div class="header-section mat-header-row">
    <mat-icon
      class="close-cross"
      tabindex="0"
      role="button"
      aria-label="close"
      aria-hidden="false"
      (click)="onCrossClick()"
      (keyup.enter)="onCrossClick()"
      (keyup.space)="onCrossClick()"
    >
      close
    </mat-icon>
  </div>
  <div class="modal-body">
    <ten-map
      *ngIf="data?.geoJSON"
      [geoJSON]="data?.geoJSON"
      [enableDirectionsToPin]="data?.enableDirectionsToPin"
      [activeFeatureId]="data?.activeFeatureId"
      [isRecenterButton]="true"
      class="ten-map"
    ></ten-map>
  </div>
</mat-dialog-content>
